// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"helper_wrapper__1A0_p","title":"helper_title__UVNsA","subtitle":"helper_subtitle__ZkUIz","resume":"helper_resume__t0IuI","knowMore":"helper_knowMore__eedLZ"};